var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcadamicsDallasDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 444.4 85.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#041e42;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 99.71,
    height: 85.53,
    rx: 7.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.2,25.47V61.14H38.49V55.43a14.89,14.89,0,0,1-12.2,6.21c-9.92,0-16.7-8.06-16.7-18.34S16.37,25,26.29,25a14.86,14.86,0,0,1,12.2,6.21V25.47ZM38.49,43.3c0-6.27-4.64-11.77-11.06-11.77S16.51,36.81,16.51,43.3,21,55.15,27.43,55.15,38.49,49.58,38.49,43.3Z",
    transform: "translate(0.05 -0.47)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.4,43.3c0-9.91,7.13-18.4,18.19-18.4a16.91,16.91,0,0,1,11.13,3.56v7.78A14.4,14.4,0,0,0,74.16,31.6a11.71,11.71,0,1,0,0,23.41,14.4,14.4,0,0,0,10.56-4.64v7.78a16.91,16.91,0,0,1-11.13,3.56C62.53,61.71,55.4,53.22,55.4,43.3Z",
    transform: "translate(0.05 -0.47)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.69,25.47V61.14H153V55.43a14.89,14.89,0,0,1-12.2,6.21c-9.92,0-16.7-8.06-16.7-18.34S130.86,25,140.78,25a14.88,14.88,0,0,1,12.2,6.2v-5.7ZM153,43.3c0-6.27-4.64-11.77-11.06-11.77S131,36.81,131,43.3s4.5,11.85,10.92,11.85S153,49.58,153,43.3Z",
    transform: "translate(0.05 -0.47)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.68,4.06V61.14H221V55.43a14.89,14.89,0,0,1-12.2,6.21c-9.92,0-16.7-8.06-16.7-18.34S198.85,25,208.77,25a14.88,14.88,0,0,1,12.2,6.2V4.06ZM221,43.3c0-6.27-4.64-11.77-11.06-11.77S199,36.81,199,43.3s4.49,11.85,10.91,11.85S221,49.58,221,43.3Z",
    transform: "translate(0.05 -0.47)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.2,46H242.94c1.07,5.63,5.5,9.2,11.63,9.2a19.93,19.93,0,0,0,11.78-3.85v6.77a20.5,20.5,0,0,1-12.13,3.57c-11.35,0-18.2-8.42-18.2-18.41S243,25,253.5,25C264.63,25,271,34.74,270.2,46ZM243,40.45h20.12c-1-5.21-4.64-8.78-9.78-8.78C247.94,31.67,244.09,35.31,243,40.45Z",
    transform: "translate(0.05 -0.47)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.91,40.38l-.07,20.76h-6.7V41.52c0-6.42-3.21-10.56-8.28-10.56s-8.35,4.14-8.35,10.77V61.14H301.8V41.52c0-6.42-3.28-10.56-8.34-10.56s-8.28,4.14-8.28,10.77l-.07-.21V61.14H278.4V25.47h6.71v4.85a12,12,0,0,1,10.42-5.57A12.25,12.25,0,0,1,306.8,32a13.49,13.49,0,0,1,12-7.21C326.13,24.75,331.91,30,331.91,40.38Z",
    transform: "translate(0.05 -0.47)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.87,14.12a4.57,4.57,0,0,1,9.14,0,4.57,4.57,0,1,1-9.14,0Zm1.22,11.35h6.7V61.14h-6.7Z",
    transform: "translate(0.05 -0.47)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.42,43.3c0-9.91,7.14-18.4,18.2-18.4a16.93,16.93,0,0,1,11.13,3.56v7.78a14.38,14.38,0,0,0-10.56-4.64,11.71,11.71,0,1,0,0,23.41,14.42,14.42,0,0,0,10.56-4.64v7.77a16.88,16.88,0,0,1-11.13,3.57C390.56,61.71,383.42,53.22,383.42,43.3Z",
    transform: "translate(0.05 -0.47)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.31,56.08l4.21-5c2.21,2.14,5.28,4.14,8.63,4.14,3,0,5.21-1.57,5.21-3.93,0-6.92-17.05-4.35-17-16.48,0-5.42,4.5-9.91,11.49-9.91A15.44,15.44,0,0,1,443.28,30l-3.92,4.92c-1.57-1.42-4.42-3.49-7.42-3.49-2.71,0-4.64,1.43-4.64,3.57-.07,6.42,17.05,4.06,17.05,16.48-.07,5.85-5,10.27-12.41,10.27A18.22,18.22,0,0,1,419.31,56.08Z",
    transform: "translate(0.05 -0.47)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.46,46.26a4.46,4.46,0,0,1,4.42-4.5,4.53,4.53,0,0,1,4.5,4.5,4.47,4.47,0,0,1-4.5,4.49A4.41,4.41,0,0,1,106.46,46.26Z",
    transform: "translate(0.05 -0.47)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.87,46.26a4.47,4.47,0,0,1,4.43-4.5,4.52,4.52,0,0,1,4.49,4.5,4.47,4.47,0,0,1-4.49,4.49A4.41,4.41,0,0,1,168.87,46.26Z",
    transform: "translate(0.05 -0.47)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.44,46.26a4.46,4.46,0,0,1,4.42-4.5,4.53,4.53,0,0,1,4.5,4.5,4.47,4.47,0,0,1-4.5,4.49A4.41,4.41,0,0,1,346.44,46.26Z",
    transform: "translate(0.05 -0.47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcadamicsDallasDark);
export default __webpack_public_path__ + "static/media/acadamics-dallas-dark.3ffc99c14d7c054d044660e1f660b2ed.svg";
export { ForwardRef as ReactComponent };